//! @ngInject
export function rejectComplianceItemPendingUploadModalCtrl($scope, $rootScope, $uibModalInstance, DatabaseApi, toaster, $filter) {

    $scope.rejectReason = "";
    $scope.selectedReason = {};
    $scope.rejectionReasons = [];
    $scope.isOnboardingAgency = $rootScope.isOnboardingAgency;

    $scope.closeModal = (result = 'cancel') => {
        $uibModalInstance.close(result);
    };

    $scope.rejectionReasonsEvents = {
      onSelectionChanged: () => {
        $scope.updateRejectReason(
            $scope.rejectionReasons.find((reason) => reason.id === $scope.selectedReason.id)?.message
        );
      },
    };

    $scope.getRejectReasons = () => {
        if ($rootScope.isOnboardingAgency){
            const url = `agencies/:agencyId/agency_members/:agencyMemberId/compliance_items/:caregiverDocumentTypeId/rejection_reasons`
                .replace(":agencyId", $rootScope.agencyId)
                .replace(":agencyMemberId", $rootScope.agencyMemberId)
                .replace(":caregiverDocumentTypeId", $scope.caregiverDocumentTypeId);
            DatabaseApi.get(url).then((res) => {
                $scope.rejectionReasons = res.data.reasons.map((reason) => ({
                    id: reason.code,
                    label: $filter("titlecasefromsnake")(reason.code),
                    message: reason.message
                }));
            }), () => {
                toaster.pop('error', 'Oops! Something went wrong', 'could not get rejection reasons');
            }
        }
    }
    
    $scope.updateRejectReason = (reason) => {
        $scope.rejectReason = reason;
    }

    $scope.submitReject = () => {
        const reason =  $scope.rejectReason !== "" ? $scope.rejectReason : null;
        const url = `agencies/${$rootScope.agencyId}/agency_members/${$rootScope.agencyMemberId}/caregivers/${$scope.pendingUpload.caregiverId}/uploaded_documents/${$scope.pendingUpload.caregiverDocumentUploadId}/reject`;
        const body = {
            reason: reason
        };
        DatabaseApi.post(url, body).then((res) => {
            toaster.pop('success', 'Successfully rejected upload');
            $scope.pendingUpload.complianceStatus = "Rejected";
            $scope.pendingUpload.complianceRejectReason = reason;
            $scope.closeModal('success');
        }, (err) => {
            toaster.pop('error', 'Oops! Something went wrong', 'could not reject upload');
        });
    }
    $scope.getRejectReasons();

};